import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors } from '../Globals/styles';
import '../../Content/Javascript/sly';

class WheelInput extends Component {
  constructor(props) {
    super(props);
    this.sly = null;
  }
  componentDidUpdate = (prevProps) => {
    if (prevProps.maxValue!==this.props.maxValue){
      this.sly.reload();
    }
    if (prevProps.maxSelectionValue!==this.props.maxSelectionValue){
      this.sly.reload();
    }
    if (prevProps.defaultValue!==this.props.defaultValue){
      this.sly.activate(this.props.defaultValue/this.props.interval)
    }
  };
  componentDidMount = () => {
    this.slySetup();
  };
  slySetup = () => {
    const { interval, defaultValue } = this.props;
    var options = {
      //main
      horizontal: true,
      //navigation
      itemNav: 'forceCentered',
      activateMiddle: true,
      activateOn: 'click',
      smart: true,
      //scroll
      scrollBy: 0,
      //dragging
      mouseDragging: true,
      touchDragging: true,
      releaseSwing: true,
      interactive: true,
      elasticBounds: true,
      // Mixed options
      speed: 300
    };
             // eslint-disable-next-line 
    this.sly = new Sly(this.refs.frame, options, {
      moveEnd: this.onChangeHandler
    });
    this.sly.init();
    //set active item according to default value
    this.sly.activate(defaultValue/interval, true)
  };
  onChangeHandler = () => {
    const { onChange, interval, maxSelectionValue } = this.props;

    var newSelected = parseFloat(this.sly.items[this.sly.rel.activeItem].el.innerHTML);

    // if new selected is the same as the old return and do nothing
    if (newSelected===this.props.defaultValue) return;

     //if maxSelectionValue is not defined just call onChange
    if (maxSelectionValue===undefined){
      onChange(newSelected)
      return;

    }
    //if new selection is higher than old one and the sum of new selection and old selection is higher than the remaining value in pool
    //do the highest possible selection
    if (newSelected > this.props.defaultValue && newSelected - this.props.defaultValue > maxSelectionValue){
      newSelected = parseFloat(maxSelectionValue) + this.props.defaultValue;
      this.sly.activate(newSelected/interval)
    }
    if (newSelected===this.props.defaultValue) return;
    onChange(newSelected)
  };
  componentWillUnmount =() => {
    this.sly.destroy();
  };
  renderItems = () => {
    const { minValue, maxValue, interval, defaultValue } = this.props;
    var items = [];
    for (var i = minValue; i <= maxValue; i+=interval) {
      items.push((<li key={i} style={[styles.item, (defaultValue===i && i!==0) && styles.active]}>{i}</li>))
    }
    return items;
  };
  render() {
    return (
      <div style={styles.frame} ref="frame">
        <ul style={[styles.slidee, this.props.ulStyles]} className="slidee">
          {this.renderItems()}
        </ul>
        <div style={styles.middleMarker}></div>
        <div style={[styles.overlay, this.props.overLayColor && {background: this.props.overLayColor}]}> </div>
      </div>
    );
  }
}

var styles = {
  frame: {
    zIndex: '100000000',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    position: 'relative',
    cursor: 'pointer',
    lineHeight: '40px'
  },
  slidee: {
    margin: '0',
    padding: '0',
    height: '100%',
    listStyle: 'none',
    color: semanticColors.text
  },
  middleMarker: {
    width: '50px',
    height: '80%',
    marginTop: '2%',
    borderLeft: "1px solid",
    borderRight: "1px solid",
    borderColor: semanticColors.mainBackground,
    position: 'absolute',
    left: '50%',
    marginLeft: '-25px',
    top: '0'
  },
  item: {
    float: 'left',
    margin:'0',
    padding: '0',
    width: '50px',
    height: '100%'
  },
  overlay: {
    position: 'absolute',
    top: '2px',
    left: '0',
    width: '100%',
    height: '35px',
    background: 'linear-gradient(to right, rgba(247,247,247,1) 2%,rgba(247,247,247,1) 6%,rgba(247,247,247,0) 50%,rgba(247,247,247,1) 92%,rgba(255,255,255,1) 200%)'
  },
  active: {
    color: semanticColors.info
  }
}

  WheelInput.propTypes = {
    minValue: PropTypes.number.isRequired,
    maxValue: PropTypes.number.isRequired,
    interval: PropTypes.number.isRequired,
    defaultValue: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    maxSelectionValue: PropTypes.number,
    overLayColor: PropTypes.string,
    ulStyles: PropTypes.object
  };

export default Radium(WheelInput);



// WEBPACK FOOTER //
// ./src/App/Common/wheelInput.jsx